import { ref } from "vue";
import { useMediaQuery } from "@vueuse/core";
import { useDownloadables } from "/composables/useDownloadables";
import { useUser } from "/composables/useUser";

import useTailwindCss from "/composables/useTailwindCss";


export default {
  __name: 'index',
  props: {
  title: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    required: false,
  },
  download: {
    type: String,
    required: false,
  },
  media: {
    type: Object,
    required: true,
  },
  layout: {
    type: String,
    required: false,
    validator: function (value) {
      return ["left", "right"].indexOf(value) !== -1;
    },
    default: "left",
  },
  isPrivate: {
    type: Boolean,
    required: false,
  },
  loading: {
    type: String,
    required: false,
    validator: function (value) {
      return ["auto", "eager", "lazy"].indexOf(value) !== -1;
    },
    default: "auto",
  },
},
  setup(__props) {

const props = __props;



const { screens } = useTailwindCss();
const { getLink } = useDownloadables();
const { logged } = useUser();

const hover = ref(false);
const isSMScreen = useMediaQuery(`(min-width: ${screens.sm.min})`);

const showModal = ref(false);

function handlePrivate(event) {
  if (!logged.value && props.isPrivate) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showModal.value = true;
  }
}

return { __sfc: true,props, screens, getLink, logged, hover, isSMScreen, showModal, handlePrivate }
}

}